export default __webpack_public_path__ + "static/media/pic2.59c281ba.jpg";